@if (bootstrapProperties$ | async; as bootstrapProperties) {
	@if (bootstrapProperties.bannerEnabled) {
		<div id="banner">
			<span class="secondary" [innerHtml]="'global.main.bannerLeftRightText' | translate | safe: 'html'"></span
			><span class="primary" [innerHtml]="'global.main.bannerCenterText' | translate | safe: 'html'"></span
			><span class="secondary" [innerHtml]="'global.main.bannerLeftRightText' | translate | safe: 'html'"></span>
		</div>
	}
	<div class="login">
		<div class="wrapper">
			<article class="card">
				<header>
					<h1 translate="login"></h1>
					<div class="logo">
						<span class="img stages"></span>
					</div>
				</header>
				<form [formGroup]="form" role="form">
					@if (getErrorMessages(bootstrapProperties); as errorMessage) {
						<div class="field errors">
							<div class="error">
								<span [translate]="errorMessage.key" [translateParams]="errorMessage.args"></span>
							</div>
						</div>
					}
					@if (bootstrapProperties.samlAuthenticationEnabled) {
						<div class="field saml">
							<div class="login-button max">
								<button
									[disabled]="isRequestRunning() || isSSORequestRunning()"
									type="button"
									(click)="samlAuthentication()"
									class="button lg prime"
									translate="login.sso"
								></button>
							</div>
							@if (samlErrors) {
								<div class="error" [translate]="samlErrors"></div>
							}
							@if (bootstrapProperties.basicAuthenticationEnabled) {
								<div class="divider">
									<span translate="login.or"></span>
								</div>
							}
						</div>
					}
					@if (bootstrapProperties.basicAuthenticationEnabled) {
						<div class="field">
							<label for="username" [translate]="'login.username'"></label>
							<input
								formControlName="username"
								type="text"
								id="username"
								name="username"
								class="text username"
								stagesAutofocus
								required
								autocapitalize="none"
								autocomplete="username"
							/>
							@if (submitted && form.get("username")!.errors?.required) {
								<div class="error" role="alert" translate="input.required"></div>
							}
						</div>
						<div class="field">
							<label for="password" [translate]="'login.password'"></label>
							<input
								#passwordInput
								formControlName="password"
								type="password"
								id="password"
								name="password"
								class="text password"
								(focus)="$any($event.target).select()"
								required
								autocomplete="off"
							/>
							@if (submitted && form.get("password")!.errors?.required) {
								<div class="error" role="alert" translate="input.required"></div>
							}
							@if ((factor2$ | async) === "NONE") {
								@if (errors) {
									<div class="error" [translate]="errors"></div>
								}
							}
						</div>
						@if (captchaImage) {
							<div class="row">
								<div class="field">
									<label for="captchaText" [translate]="'login.captcha'"></label>
									<div>
										<input
											formControlName="captchaText"
											type="text"
											id="captchaText"
											name="captchaText"
											class="text captcha"
											stagesAutofocus
											autocapitalize="none"
											autocomplete="username"
										/>
										<img [src]="'data:image/png;base64,' + captchaImage" alt="captcha-image" class="captcha-image" />
									</div>
								</div>
							</div>
						}
						@if (factor2$ | async; as otpType) {
							@if (otpType === "HOTP" || otpType === "TOTP") {
								<div class="field">
									<label for="code" [translate]="'login.code.' + otpType"></label>
									<input
										#codeInput
										[stagesAutofocus]
										formControlName="code"
										type="text"
										id="code"
										name="code"
										class="text"
										required
										inputmode="numeric"
										pattern="[0-9]*"
										autocomplete="one-time-code"
										(focus)="$any($event.target).select()"
									/>
									@if (codeSubmitted && form.get("code")!.errors?.required) {
										<div class="error" role="alert" translate="input.required"></div>
									}
									@if ((factor2$ | async) !== "NONE") {
										@if (errors) {
											<div class="error" [translate]="errors"></div>
										}
									}
								</div>
							}
						}
						<div class="row">
							@if (bootstrapProperties.cookieLoginEnabled && !bootstrapProperties.samlAuthenticationEnabled) {
								<div class="field">
									<input
										formControlName="rememberUser"
										type="checkbox"
										id="remember-me"
										name="remember-me"
										class="checkbox"
									/><label for="remember-me" [translate]="'login.autologin'"></label>
								</div>
							}
						</div>
						<div class="login-button max">
							@switch (isRequestRunning()) {
								@case (false) {
									<button
										[disabled]="isSSORequestRunning()"
										(click)="passwordAuthentication()"
										class="button lg prime"
										[ngClass]="{ outlined: bootstrapProperties.samlAuthenticationEnabled }"
										translate="login.submit"
									></button>
								}
								@case (true) {
									<button
										[disabled]="true"
										class="button lg prime"
										[ngClass]="{ outlined: bootstrapProperties.samlAuthenticationEnabled }"
									>
										<stages-spin size="sm"></stages-spin>
									</button>
								}
							}
						</div>
					}
					@if (!!helpDeskInformation || !!helpDeskLinkHref) {
						<div class="row helpdesk">
							<p>
								@if (!!helpDeskInformation) {
									<span>{{ helpDeskInformation }}&nbsp;</span>
								}
								@if (!!helpDeskLinkHref) {
									<a target="_blank" href="{{ getHrefForExternalLink(helpDeskLinkHref) }}">
										@if (!!helpDeskLinkText) {
											<span>{{ helpDeskLinkText }}</span>
										}
										@if (!helpDeskLinkText) {
											<span>{{ helpDeskLinkText }}</span>
										}
									</a>
								}
							</p>
						</div>
					}
				</form>
			</article>
		</div>
	</div>
}
